export enum DashboardVisualizationTypeEnum {
  Standard = 0,
  Cinema = 1,
}
